<div class="flex flex-col">
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-col" style="flex:0 0 48%">
      <mat-form-field appearance="outline" class="w-p-100" style="padding:2px ;">
        <mat-label>From Language *</mat-label>
        <mat-select [disabled]="translationConfig.status===translationStatus.InProgress" placeholder="Select a Language"
                    [(ngModel)]="translationConfig.fileOneLanguage" data-copilot="language-settings-select-from-language">
          <mat-option *ngFor="let language of translationSupportiveLanguage" [value]="language.code"
                      [attr.data-copilot]="'language-settings-option-from-' + language.code">
            {{language.name}}
          </mat-option>
        </mat-select>
        <mat-hint *ngIf="translationConfig.fileOneLanguage !== originalConfig.fileOneLanguage">
          Value changed!!!
        </mat-hint>
      </mat-form-field>
    </div>
    <div class="flex flex-col" style="flex: 0 0 48%">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>To Language *</mat-label>
        <mat-select [disabled]="translationConfig.status===translationStatus.InProgress" placeholder="Select a Language"
                    [(ngModel)]="translationConfig.fileTwoLanguage" data-copilot="language-settings-select-to-language">
          <mat-option *ngFor="let language of translationSupportiveLanguage" [value]="language.code"
                      [attr.data-copilot]="'language-settings-option-to-' + language.code">
            {{language.name}}
          </mat-option>
        </mat-select>
        <mat-hint *ngIf="translationConfig.fileTwoLanguage !== originalConfig.fileTwoLanguage">
          Value changed!!!
        </mat-hint>
      </mat-form-field>
    </div>
  </div>
</div>
